module.exports = __webpack_public_path__ + "static/media/ri.7b47ef69.svg";